import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';



export default function CircularIndeterminate() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: "100%",
        height: '100vh',
      }}
    >
      <CircularProgress
        size={50}
        thickness={4}
        sx={{
          color: 'primary.main',
        }}
      />
    </Box>
  );
}
